import { atom } from "jotai";

interface CollabAPI {
    addStickyNote: (stickyNote: any) => void;
}

export const collabAPIAtom = atom<CollabAPI | null>(null);